import * as React from 'react'

import { Card } from '@grandvisionhq/common'
import { useIntl } from '@grandvisionhq/state'

import { SummaryProps } from '../types'

const ContactDetailsSummary = ({ actions, values = {} }: SummaryProps) => {
  const { getLabel } = useIntl()

  return (
    <Card>
      <Card.Content>
        {actions?.onEdit && (
          <Card.Actions>
            <Card.Button onClick={actions.onEdit} children={getLabel('common.actions.edit')} />
          </Card.Actions>
        )}
        <Card.Text>
          {values.firstName} {values.lastName}
        </Card.Text>
        <Card.Text>{values.email}</Card.Text>
        {values.phone && <Card.Text>{values.phone}</Card.Text>}
      </Card.Content>
    </Card>
  )
}

export default ContactDetailsSummary
